export const background = '#111A41';
export const highlight = '#2C3763';
export const accent = 'var(--color-primary-500)';
export const icon = '#c4c5cc';
export const iconHover = 'white';
export const iconActive = 'var(--color-primary-500)';
export const text = '#a7abbb';
export const textHover = 'white';
export const textActive = 'white';
